// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.3.0
//   protoc               v5.27.3
// source: confidence/flags/resolver/v1/api.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire';
import { Struct } from '../../../../google/protobuf/struct';
import { Timestamp } from '../../../../google/protobuf/timestamp';
import { FlagSchema_StructFlagSchema } from '../../types/v1/types';
import { resolveReasonFromJSON, resolveReasonToJSON, Sdk } from './types';
export const protobufPackage = 'confidence.flags.resolver.v1';
function createBaseResolveFlagsRequest() {
    return { flags: [], evaluationContext: undefined, clientSecret: '', apply: false, sdk: undefined };
}
export const ResolveFlagsRequest = {
    encode(message, writer = new BinaryWriter()) {
        for (const v of message.flags) {
            writer.uint32(10).string(v);
        }
        if (message.evaluationContext !== undefined) {
            Struct.encode(Struct.wrap(message.evaluationContext), writer.uint32(18).fork()).join();
        }
        if (message.clientSecret !== '') {
            writer.uint32(26).string(message.clientSecret);
        }
        if (message.apply !== false) {
            writer.uint32(32).bool(message.apply);
        }
        if (message.sdk !== undefined) {
            Sdk.encode(message.sdk, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResolveFlagsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.flags.push(reader.string());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.evaluationContext = Struct.unwrap(Struct.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.clientSecret = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.apply = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.sdk = Sdk.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            flags: globalThis.Array.isArray(object?.flags) ? object.flags.map((e) => globalThis.String(e)) : [],
            evaluationContext: isObject(object.evaluationContext) ? object.evaluationContext : undefined,
            clientSecret: isSet(object.clientSecret) ? globalThis.String(object.clientSecret) : '',
            apply: isSet(object.apply) ? globalThis.Boolean(object.apply) : false,
            sdk: isSet(object.sdk) ? Sdk.fromJSON(object.sdk) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.flags?.length) {
            obj.flags = message.flags;
        }
        if (message.evaluationContext !== undefined) {
            obj.evaluationContext = message.evaluationContext;
        }
        if (message.clientSecret !== '') {
            obj.clientSecret = message.clientSecret;
        }
        if (message.apply !== false) {
            obj.apply = message.apply;
        }
        if (message.sdk !== undefined) {
            obj.sdk = Sdk.toJSON(message.sdk);
        }
        return obj;
    },
};
function createBaseResolveFlagsResponse() {
    return { resolvedFlags: [], resolveToken: new Uint8Array(0), resolveId: '' };
}
export const ResolveFlagsResponse = {
    encode(message, writer = new BinaryWriter()) {
        for (const v of message.resolvedFlags) {
            ResolvedFlag.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.resolveToken.length !== 0) {
            writer.uint32(18).bytes(message.resolveToken);
        }
        if (message.resolveId !== '') {
            writer.uint32(26).string(message.resolveId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResolveFlagsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.resolvedFlags.push(ResolvedFlag.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.resolveToken = reader.bytes();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.resolveId = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            resolvedFlags: globalThis.Array.isArray(object?.resolvedFlags)
                ? object.resolvedFlags.map((e) => ResolvedFlag.fromJSON(e))
                : [],
            resolveToken: isSet(object.resolveToken) ? bytesFromBase64(object.resolveToken) : new Uint8Array(0),
            resolveId: isSet(object.resolveId) ? globalThis.String(object.resolveId) : '',
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.resolvedFlags?.length) {
            obj.resolvedFlags = message.resolvedFlags.map(e => ResolvedFlag.toJSON(e));
        }
        if (message.resolveToken.length !== 0) {
            obj.resolveToken = base64FromBytes(message.resolveToken);
        }
        if (message.resolveId !== '') {
            obj.resolveId = message.resolveId;
        }
        return obj;
    },
};
function createBaseApplyFlagsRequest() {
    return { flags: [], clientSecret: '', resolveToken: new Uint8Array(0), sendTime: undefined, sdk: undefined };
}
export const ApplyFlagsRequest = {
    encode(message, writer = new BinaryWriter()) {
        for (const v of message.flags) {
            AppliedFlag.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.clientSecret !== '') {
            writer.uint32(18).string(message.clientSecret);
        }
        if (message.resolveToken.length !== 0) {
            writer.uint32(26).bytes(message.resolveToken);
        }
        if (message.sendTime !== undefined) {
            Timestamp.encode(toTimestamp(message.sendTime), writer.uint32(34).fork()).join();
        }
        if (message.sdk !== undefined) {
            Sdk.encode(message.sdk, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApplyFlagsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.flags.push(AppliedFlag.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.clientSecret = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.resolveToken = reader.bytes();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.sendTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.sdk = Sdk.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            flags: globalThis.Array.isArray(object?.flags) ? object.flags.map((e) => AppliedFlag.fromJSON(e)) : [],
            clientSecret: isSet(object.clientSecret) ? globalThis.String(object.clientSecret) : '',
            resolveToken: isSet(object.resolveToken) ? bytesFromBase64(object.resolveToken) : new Uint8Array(0),
            sendTime: isSet(object.sendTime) ? fromJsonTimestamp(object.sendTime) : undefined,
            sdk: isSet(object.sdk) ? Sdk.fromJSON(object.sdk) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.flags?.length) {
            obj.flags = message.flags.map(e => AppliedFlag.toJSON(e));
        }
        if (message.clientSecret !== '') {
            obj.clientSecret = message.clientSecret;
        }
        if (message.resolveToken.length !== 0) {
            obj.resolveToken = base64FromBytes(message.resolveToken);
        }
        if (message.sendTime !== undefined) {
            obj.sendTime = message.sendTime.toISOString();
        }
        if (message.sdk !== undefined) {
            obj.sdk = Sdk.toJSON(message.sdk);
        }
        return obj;
    },
};
function createBaseApplyFlagsResponse() {
    return {};
}
export const ApplyFlagsResponse = {
    encode(_, writer = new BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseApplyFlagsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
};
function createBaseAppliedFlag() {
    return { flag: '', applyTime: undefined };
}
export const AppliedFlag = {
    encode(message, writer = new BinaryWriter()) {
        if (message.flag !== '') {
            writer.uint32(10).string(message.flag);
        }
        if (message.applyTime !== undefined) {
            Timestamp.encode(toTimestamp(message.applyTime), writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAppliedFlag();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.flag = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.applyTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            flag: isSet(object.flag) ? globalThis.String(object.flag) : '',
            applyTime: isSet(object.applyTime) ? fromJsonTimestamp(object.applyTime) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.flag !== '') {
            obj.flag = message.flag;
        }
        if (message.applyTime !== undefined) {
            obj.applyTime = message.applyTime.toISOString();
        }
        return obj;
    },
};
function createBaseResolvedFlag() {
    return { flag: '', variant: '', value: undefined, flagSchema: undefined, reason: 0, shouldApply: false };
}
export const ResolvedFlag = {
    encode(message, writer = new BinaryWriter()) {
        if (message.flag !== '') {
            writer.uint32(10).string(message.flag);
        }
        if (message.variant !== '') {
            writer.uint32(18).string(message.variant);
        }
        if (message.value !== undefined) {
            Struct.encode(Struct.wrap(message.value), writer.uint32(26).fork()).join();
        }
        if (message.flagSchema !== undefined) {
            FlagSchema_StructFlagSchema.encode(message.flagSchema, writer.uint32(34).fork()).join();
        }
        if (message.reason !== 0) {
            writer.uint32(40).int32(message.reason);
        }
        if (message.shouldApply !== false) {
            writer.uint32(48).bool(message.shouldApply);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResolvedFlag();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.flag = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.variant = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.value = Struct.unwrap(Struct.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.flagSchema = FlagSchema_StructFlagSchema.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.reason = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.shouldApply = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            flag: isSet(object.flag) ? globalThis.String(object.flag) : '',
            variant: isSet(object.variant) ? globalThis.String(object.variant) : '',
            value: isObject(object.value) ? object.value : undefined,
            flagSchema: isSet(object.flagSchema) ? FlagSchema_StructFlagSchema.fromJSON(object.flagSchema) : undefined,
            reason: isSet(object.reason) ? resolveReasonFromJSON(object.reason) : 0,
            shouldApply: isSet(object.shouldApply) ? globalThis.Boolean(object.shouldApply) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.flag !== '') {
            obj.flag = message.flag;
        }
        if (message.variant !== '') {
            obj.variant = message.variant;
        }
        if (message.value !== undefined) {
            obj.value = message.value;
        }
        if (message.flagSchema !== undefined) {
            obj.flagSchema = FlagSchema_StructFlagSchema.toJSON(message.flagSchema);
        }
        if (message.reason !== 0) {
            obj.reason = resolveReasonToJSON(message.reason);
        }
        if (message.shouldApply !== false) {
            obj.shouldApply = message.shouldApply;
        }
        return obj;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, 'base64'));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString('base64');
    }
    else {
        const bin = [];
        arr.forEach(byte => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(''));
    }
}
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1_000);
    const nanos = (date.getTime() % 1_000) * 1_000_000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1_000;
    millis += (t.nanos || 0) / 1_000_000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === 'string') {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(Timestamp.fromJSON(o));
    }
}
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=api.js.map